<div class="row" *ngIf="loading">
  <div class="col">
    <div class="alert alert-warning">Loading... <app-spin-icon></app-spin-icon>
    </div>
  </div>
</div>
<div class="row" *ngIf="!loading">
  <div class="col">
    <div class="card card-cascade wider col-md-10 col-lg-8 col-12 ml-auto mr-auto">
      <div class="view gradient-card-header secondary-gradient">
        <h4>Billing Card</h4>
      </div>
      <div class="card-body text-center" *ngIf="!Billing.hasCards()">
        <p class="alert alert-info">There is no card setup on file.</p>
        <div class="text-center">
          <input type="button" class="btn btn-secondary" value="Setup Payment Card" (click)="setupCard()" />
        </div>
      </div>
      <div class="card-body" *ngIf="Billing.hasCards()">
        <h6>Billing Email On File <b>{{Billing.email}}</b></h6>

        <div *ngIf="Billing.hasCards()" class="row">
          <div class="col-12" *ngFor="let card of Billing.cards">
            <dac-billing-card [card]="card"></dac-billing-card>
            <input type="button" class="btn btn-secondary" value="Update Card" (click)="setupCard()" />
            <i class="fa fa-trash" class="btn btn-danger fa fa-trash" alt="Remove Saved Card" title="Remove Saved Card"
              (click)="removeCard()"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/shared/billing-details/billing-details.component.html